import React, { useMemo } from "react";
import objectPath from "object-path";
// LayoutContext
import { useHtmlClassService } from "../_core/MetronicLayout";
// Import Layout components
// import { Header } from "./header/Header";
import { HeaderMobile } from "./header-mobile/HeaderMobile";
// import { Aside } from "./aside/Aside";
// import { Footer } from "./footer/Footer";
import { LayoutInit } from "./LayoutInit";
// import { SubHeader } from "./subheader/SubHeader";
import { QuickPanel } from "./extras/offcanvas/QuickPanel";
// import { QuickUser } from "./extras/offcanvas/_QuickUser";
import { ScrollTop } from "./extras/ScrollTop";
// import { StickyToolbar } from "./extras/StickyToolbar";
import { useHistory } from "react-router-dom";
import { AsideMenuList } from "./aside/aside-menu/AsideMenuList";
import { shallowEqual, useSelector } from "react-redux";
import AppHeader from "./header/Header";
export function Layout({ children }) {
  const { currentState } = useSelector((state) => ({ currentState: state.sideBar }), shallowEqual);
  const { setCollapsed, isVisible } = currentState;
  const history = useHistory();
  // history.location
  let h = history.location.pathname.split("/");

  const uiService = useHtmlClassService();
  // Layout settings (cssClasses/cssAttributes)
  const layoutProps = useMemo(() => {
    return {
      layoutConfig: uiService.config,
      selfLayout: objectPath.get(uiService.config, "self.layout"),
      asideDisplay: objectPath.get(uiService.config, "aside.self.display"),
      subheaderDisplay: objectPath.get(uiService.config, "subheader.display"),
      desktopHeaderDisplay: objectPath.get(uiService.config, "header.self.fixed.desktop"),
      contentCssClasses: uiService.getClasses("content", true),
      contentContainerClasses: uiService.getClasses("content_container", true),
      contentExtended: objectPath.get(uiService.config, "content.extended"),
    };
  }, [uiService]);

  return layoutProps.selfLayout !== "blank" ? (
    <>
      {/*begin::Main*/}
      <HeaderMobile />
      <div className="d-flex flex-column flex-root">
        {/*begin::Page*/}
        <div className="d-flex flex-row flex-column-fluid page">
          <div id="kt_aside_menu">{isVisible && <AsideMenuList />}</div>
          {/*begin::Wrapper*/}
          <div
            className="d-flex flex-column flex-row-fluid "
            id="kt_wrapper"
            style={!isVisible ? { marginLeft: "0px", paddingTop: "0px" } : setCollapsed ? { marginLeft: "125px" } : { marginLeft: "280px" }}
          >
            {isVisible && <AppHeader />}
            {/* <Header /> */}
            {/*begin::Content*/}
            <div
              id="kt_content"
              style={isVisible ? { paddingTop: "84px", background: "#fff" } : { paddingTop: "0px", background: "#fff" }}
              className={`content ${layoutProps.contentCssClasses} d-flex flex-column flex-column-fluid`}
            >
              {/* {layoutProps.subheaderDisplay && <SubHeader />} */}
              {/*begin::Entry*/}
              {!layoutProps.contentExtended && (
                <div className="d-flex flex-column-fluid">
                  {/*begin::Container*/}
                  <div
                    className={
                      h[1] == "inventory" && h[2] == "purchase" && h[3] == "order" && h[5] == "detail"
                        ? "container-fluid"
                        : `${layoutProps.contentContainerClasses}`
                    }
                  >
                    {children}
                  </div>
                  {/*end::Container*/}
                </div>
              )}

              {layoutProps.contentExtended && { children }}
              {/*end::Entry*/}
            </div>
            {/*end::Content*/}
            {/* For Now we are hiding footer from the portal */}
            {/* <Footer /> */}
          </div>
          {/*end::Wrapper*/}
        </div>
        {/*end::Page*/}
      </div>
      {/* <QuickUser /> */}
      <QuickPanel />
      <ScrollTop />
      {/* <StickyToolbar /> */}
      {/*end::Main*/}
      <LayoutInit />
    </>
  ) : (
    // BLANK LAYOUT
    <div className="d-flex flex-column flex-root">{children}</div>
  );
}
